import { INpsSurvey } from '@aca-new/app/pages/book/pages/confirmation/shared/components/nps-survey/shaerd/models/interfaces/nps-survey.interface';
import { AI_API_ACCESS_TOKEN_GREY_LABEL } from '@aca-new/app/shared/constants/ai-api-access-token.constants';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { HttpService } from '@aca-new/app/shared/services/http-services/http.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Md5 } from 'ts-md5';

@Injectable({
  providedIn: 'root',
})
export class NpsSurveyApiService {
  public constructor(
    private readonly _storageService: StorageService,
    private readonly _httpService: HttpService
  ) {}

  public saveSurvey$(data: INpsSurvey): Observable<void> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);
    const sign = Md5.hashStr(`${(data.date || '') + (data.npsFrom || '') + (data.likeDegree || '') + (data.orderNo || '')}${AI_API_ACCESS_TOKEN_GREY_LABEL.slice(0, 8)}`);

    return this._httpService.httpClient
      .post<void>(
        `${SERVER_URL}/user/${userId}/nps-survey`,
        {
          ...data,
        },
        { observe: 'body', params: { sign } }
      )
      .pipe(map((response: void): void => response));
  }
}
